import {Injectable, signal} from '@angular/core';

const STORAGE_KEY = 'organisation-portal-dark-mode';

@Injectable({providedIn: 'root'})
export class ThemeService {
  readonly isDark = signal(this.loadPreference());

  toggle(): void {
    const dark = !this.isDark();
    this.isDark.set(dark);
    this.applyTheme(dark);
    localStorage.setItem(STORAGE_KEY, String(dark));
  }

  init(): void {
    this.applyTheme(this.isDark());
  }

  private applyTheme(dark: boolean): void {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  }

  private loadPreference(): boolean {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  }
}
